/** angular */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
/** end angular */

/** services */
import { BydRhsAbstractService } from '../../../shared/services/byd-rhs-abstract.service';
/** end services */

/** models */
import { DsDocsExportResponse } from '../models/ds-docs-export-response.class';
/** end models */

/** interface */
import { DsDocsExportResponseInterface } from '../interfaces/ds-docs-export-response.interface';
/** end interface */

/** functions */
import { BydGenerateParams } from '../../../functions/byd-generate-params.function';
import { Params } from '@angular/router';

/** end functions */
@Injectable({
  providedIn: 'root',
})
export class DsDocsExportService extends BydRhsAbstractService {
  /**
   * Implement inherited abstract member 'path' from BydRhsAbstractService
   */
  public path: string;

  /**
   * Start custom word export.
   *
   * @param projectId Project ID.
   * @param queryParams Template ID.
   * @returns Observable<DsDocsExportResponse>.
   */
  public startCustomExport(projectId: number, queryParams: Params): Observable<DsDocsExportResponse> {
    this.path = `/v1/bimdata/projects/${projectId}/custom/exports`;
    const params = BydGenerateParams(queryParams);
    return this.getModel<DsDocsExportResponse>({ params });
  }

  /**
   * Create DsDocsExportResponse instance.
   *
   * @param  jsonObject The flat json object.
   * @returns an `DsDocsExportResponse` instance.
   */
  public createNewInstance(jsonObject: DsDocsExportResponseInterface) {
    return new DsDocsExportResponse(jsonObject);
  }
}
